import script from "./demo-day-connect-investor-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./demo-day-connect-investor-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__